<template lang="html">
    <router-link
        :to="{ name: 'Home' }"
        class="logo-link">
        <div class="logo-svg"></div>
    </router-link>
</template>

<script>
export default {
    name: 'LogoSvg'
};
</script>

<style lang="scss">
.logo-svg {
    display: block;
    position: relative;
    padding-bottom: 50px / 125px * 100%;
    background: url('../../../../static/images/logo_cartoview.png');
    background-repeat: no-repeat;
    background-size: contain;
}
.logo-link {
    display: block;
}
</style>


// WEBPACK FOOTER //
// src/components/partials/ui/LogoSvg.vue